import { render, staticRenderFns } from "./addRoleDialog.vue?vue&type=template&id=03bd4509"
import script from "./addRoleDialog.vue?vue&type=script&lang=js"
export * from "./addRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports